<!-- Vendor Selection Section -->
<div *ngIf="format == 'upload' && stepDetails?.can_edit" class="mb-6 mx-2">
  <div class="bg-white rounded shadow-md p-4 border border-blue-200">
    <h2 class="text-lg font-bold text-blue-900 mb-4 flex items-center gap-2">
      <i class="pi pi-cloud-upload text-blue-600 text-xl"></i>
       Select from Master List
      <button 
        *ngIf="files.file1 && files.file2" 
        class="inline-flex items-center gap-2 ml-4 px-3 py-1 text-sm font-semibold rounded shadow-md border-2 border-purple-500 bg-purple-100 text-purple-700 hover:bg-purple-500 hover:text-white transition"
        (click)="submitFiles()"
      >
        <i class="pi pi-check-circle mr-2"></i> Submit
      </button>
    </h2>
    <div class="grid grid-cols-1 gap-8">
      <div class="col-span-2 flex flex-col bg-slate-50 rounded border border-slate-200 p-3 shadow transition hover:bg-slate-100">
        <label for="vendorMasterDropdown" class="font-semibold text-slate-700 mb-3 flex items-center">
          <i class="pi pi-user-plus mr-2 text-indigo-700"></i>
          Select Vendor from Master List
        </label>
        <p-multiSelect
          [options]="masterVendorList"
          [(ngModel)]="selectedMasterVendor"
          optionLabel="name"
          [filter]="true"
          optionValue="id"
          filterBy="name"
          placeholder="Select Vendor(s)"
          display="chip"
          [showToggleAll]="true"
          [showClear]="true"
          [maxSelectedLabels]="3"
          defaultLabel="Select Vendor(s)"
          styleClass="w-full mb-3"
        ></p-multiSelect>
        <div class="flex gap-2 mt-2">
          <button
            [disabled]="!selectedMasterVendor?.length"
            type="button"
            id="vendorMasterDropdown"
            class="inline-flex items-center px-5 py-2 bg-emerald-600 text-white rounded shadow hover:bg-emerald-700 transition disabled:bg-slate-300 disabled:cursor-not-allowed"
            (click)="addVendorFromMaster()"
          >
            <i class="pi pi-plus-circle mr-2"></i>
            Add Selected
          </button>
          <button
            class="inline-flex items-center px-5 py-2 bg-yellow-500 text-white rounded shadow hover:bg-yellow-600 transition"
            (click)="openAdd()"
            type="button"
          >
            <i class="pi pi-user-edit mr-2"></i>
            Add New Vendor
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Vendor List Display -->
<div class="mb-10 mt-8 transition-all duration-200 hover:shadow-md" *ngIf="winners?.length > 0">
  <div class="divide-y divide-gray-200">
    <ng-container *ngFor="let row of winners; let i = index">
      <div>
        <!-- Header -->
        <div
          class="flex items-center justify-between p-4 my-3 cursor-pointer bg-gray-300/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200"
          (click)="toggleVendorSection(row)"
        >
          <div class="flex items-center">
            <!-- First letter of vendor name -->
            <span
              class="w-8 h-8 rounded-lg bg-purple-100 text-purple-600 flex items-center justify-center mr-3 text-base font-bold"
            >
              {{ row.name?.charAt(0) || row.vendor?.name?.charAt(0) || '-' }}
            </span>

            <!-- Vendor name -->
            <span class="font-semibold text-lg">
              {{ row.name || row.vendor?.name || '-' }}
            </span>

            <!-- Status chip -->
            <span
              *ngIf="row.vendor_status"
              class="ml-3 px-2 py-1 text-sm font-medium border-2 rounded-lg"
              [ngClass]="{
                'border-green-600 text-green-600 bg-green-100': row.vendor_status === 'Qualify',
                'border-red-600 text-red-600 bg-red-100': row.vendor_status === 'Disqualify'
              }"
            >
              {{
                row.vendor_status === 'Qualify' ? 'Qualified'
                : row.vendor_status === 'Disqualify' ? 'Disqualified'
                : row.vendor_status
              }}
            </span>
          </div>

          <!-- Qualify / Disqualify buttons -->
          <div class="flex gap-2" *ngIf="!row.vendor_status && ['pds-pru-evaluation', 'evaluation', 'screening'].includes(format)">
            <button
              [disabled]="!stepDetails.can_edit"
              class="px-3 py-1 text-sm font-semibold rounded border border-green-600 text-green-600 bg-green-100 hover:bg-green-50 transition disabled:opacity-50"
              (click)="setStatus(row, 'Qualify'); $event.stopPropagation()"
            >
              <i class="pi pi-check-circle mr-2"></i>Qualify
            </button>

            <button
              [disabled]="!stepDetails.can_edit"
              class="px-3 py-1 text-sm font-semibold rounded border border-red-600 bg-red-100 text-red-600 hover:bg-red-50 transition disabled:opacity-50"
              (click)="setStatus(row, 'Disqualify'); $event.stopPropagation()"
            >
              <i class="pi pi-times-circle mr-2"></i>Disqualify
            </button>
          </div>

          <i
            class="pi transition-transform duration-200"
            [ngClass]="row.isSectionOpen ? 'pi-chevron-down' : 'pi-chevron-right'"
          ></i>
        </div>

        <!-- Details section -->
        <div
          *ngIf="row.isSectionOpen"
          class="p-1 space-y-4 border-t border-slate-100 animate-fade-in"
        >
          <div class="bg-white rounded-lg shadow-sm p-2 border border-gray-200 mx-auto max-w-7xl">
            <app-vender-specfic-document
              [proposalStep]="stepDetails"
              [vendorId]="row.vendor?.id || row.id"
              [isEdit]="stepDetails?.can_edit && !['evaluation', 'screening'].includes(format)"
              [url]="url"
            >
            </app-vender-specfic-document>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Vendor Details Dialog -->
<p-dialog 
  header="Vendor Details" 
  [(visible)]="visible" 
  [modal]="true" 
  [resizable]="true" 
  [maximizable]="true"
  [style]="{ width: '600px' }" 
  appendTo="body"
>
  <form [formGroup]="commentForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="row g-3 mt-2">
      <!-- Vendor Name -->
      <div class="col-12">
        <div class="row align-items-center">
          <label for="vendor" class="col-sm-3 col-form-label bg-primary text-white py-2">
            Vendor Name <b class="text-warning">*</b>
          </label>
          <div class="col-sm-9">
            <input 
              id="vendor" 
              type="text" 
              class="form-control"
              [ngClass]="{'is-invalid': commentForm.get('vendor')?.touched && commentForm.get('vendor')?.invalid}"
              formControlName="vendor" 
              autocomplete="off" 
              maxlength="100"
            />
            <div class="invalid-feedback">Vendor Name is required (max 100 chars).</div>
          </div>
        </div>
      </div>

      <!-- Contact Person -->
      <div class="col-12">
        <div class="row align-items-center">
          <label for="contactPerson" class="col-sm-3 col-form-label bg-primary text-white py-2">
            Contact Person's Name <b class="text-warning">*</b>
          </label>
          <div class="col-sm-9">
            <input 
              id="contactPerson" 
              type="text" 
              class="form-control"
              [ngClass]="{'is-invalid': commentForm.get('contactPerson')?.touched && commentForm.get('contactPerson')?.invalid}"
              formControlName="contactPerson" 
              autocomplete="off" 
              maxlength="100"
            />
            <div class="invalid-feedback">
              <ng-container *ngIf="commentForm.get('contactPerson')?.hasError('required')">Required.</ng-container>
              <ng-container *ngIf="commentForm.get('contactPerson')?.hasError('pattern')">Only alphabets and spaces allowed.</ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- Email -->
      <div class="col-12">
        <div class="row align-items-center">
          <label for="email" class="col-sm-3 col-form-label bg-primary text-white py-2">
            Email <b class="text-warning">*</b>
          </label>
          <div class="col-sm-9">
            <input 
              id="email" 
              type="email" 
              class="form-control"
              [ngClass]="{'is-invalid': commentForm.get('email')?.touched && commentForm.get('email')?.invalid}"
              formControlName="email" 
              autocomplete="off"
            />
            <div class="invalid-feedback">
              <ng-container *ngIf="commentForm.get('email')?.hasError('required')">Email is required.</ng-container>
              <ng-container *ngIf="commentForm.get('email')?.hasError('email')">Invalid email format.</ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- Phone -->
      <div class="col-12">
        <div class="row align-items-center">
          <label for="phone" class="col-sm-3 col-form-label bg-primary text-white py-2">
            Phone Number <b class="text-warning">*</b>
          </label>
          <div class="col-sm-9">
            <div class="input-group">
              <span class="input-group-text">+91</span>
              <input 
                id="phone" 
                type="text" 
                class="form-control"
                [ngClass]="{'is-invalid': commentForm.get('phone')?.touched && commentForm.get('phone')?.invalid}"
                formControlName="phone" 
                autocomplete="off" 
                inputmode="numeric" 
                maxlength="10" 
                minlength="10"
                placeholder="Enter 10-digit number" 
                (keypress)="allowOnlyNumbers($event)"
              />
              <div class="invalid-feedback">
                <ng-container *ngIf="commentForm.get('phone')?.hasError('required')">Phone number is required.</ng-container>
                <ng-container *ngIf="commentForm.get('phone')?.hasError('pattern')">Enter a valid 10-digit phone number.</ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Address -->
      <div class="col-12">
        <div class="row align-items-center">
          <label for="address" class="col-sm-3 col-form-label bg-primary text-white py-2">
            Address <b class="text-warning">*</b>
          </label>
          <div class="col-sm-9">
            <input 
              id="address" 
              type="text" 
              class="form-control"
              [ngClass]="{'is-invalid': commentForm.get('address')?.touched && commentForm.get('address')?.invalid}"
              formControlName="address" 
              autocomplete="off" 
              maxlength="500"
            />
            <div class="invalid-feedback">Address is required (max 500 chars).</div>
          </div>
        </div>
      </div>

      <!-- Tax Registration Number -->
      <div class="col-12">
        <div class="row align-items-center">
          <label for="taxNumber" class="col-sm-3 col-form-label bg-primary text-white py-2">
            GST Number <b class="text-warning">*</b>
          </label>
          <div class="col-sm-9">
            <input 
              id="taxNumber" 
              type="text" 
              class="form-control"
              [ngClass]="{'is-invalid': commentForm.get('taxNumber')?.touched && commentForm.get('taxNumber')?.invalid}"
              formControlName="taxNumber" 
              autocomplete="off" 
              maxlength="100"
            />
            <div class="invalid-feedback">Tax Number is required (max 100 chars).</div>
          </div>
        </div>
      </div>

      <!-- Bank Account Details -->
      <div class="col-12">
        <div class="row align-items-center">
          <label for="bankDetails" class="col-sm-3 col-form-label bg-primary text-white py-2">
            Bank Account Details <b class="text-warning">*</b>
          </label>
          <div class="col-sm-9">
            <input 
              id="bankDetails" 
              type="text" 
              class="form-control"
              [ngClass]="{'is-invalid': commentForm.get('bankDetails')?.touched && commentForm.get('bankDetails')?.invalid}"
              formControlName="bankDetails" 
              autocomplete="off" 
              maxlength="500"
            />
            <div class="invalid-feedback">Bank Details are required (max 500 chars).</div>
          </div>
        </div>
      </div>

      <!-- Submit -->
      <div class="col-12 d-flex justify-content-end">
        <button type="submit" class="btn btn-primary px-4" [disabled]="commentForm.invalid">
          Submit
        </button>
      </div>
    </div>
  </form>
</p-dialog>

